// extracted by mini-css-extract-plugin
module.exports = {"statusHeight":"page_statusHeight__aNlax","navbarHeight":"page_navbarHeight__3xNNG","saveBottomX":"page_saveBottomX__x-66E","saveBottom":"page_saveBottom__q9NU5"};